<template>
    <tr>
        <td>
            <div
                v-if="!hasIcon"
                class="img"
            >
                <img :src="image">
            </div>
            <i
                v-else
                :class="icon"
            />
        </td>
        <td :title="title">
            <template
                v-if="isTransfer"
            >
                <p
                    class="big"
                >
                    {{ `transfer.${title}` | trans | truncate }}
                </p>
                <p
                    class="small"
                >
                    <span
                        :title="`transfer.${attributes.meeting}` | trans"
                    >
                        {{ 'transfer.meeting' | trans }}
                        : {{ attributes.meeting_text | truncate(15)}}
                    </span>
                    <br>
                    <span
                        :title="`transfer.${attributes.destination}` | trans"
                    >
                        {{ 'transfer.destination' | trans }}
                        : {{ attributes.destination_text | truncate(15)}}
                    </span>
                    <br>
                    <span>
                        {{ 'transfer.passengers' | trans }}: {{ attributes.passengers }}
                    </span>
                </p>
            </template>
            <template
                v-else
            >
                {{ title | truncate }}
            </template>
        </td>
        <td>
            <div
                class="gl-spinner quantity"
                v-if="editable && !isTransfer"
            >
                <button class="minus" style="cursor: pointer;" @click="removeOne">
                    <i class="gli-previus" />
                </button>
                <span>{{ quant }}</span>
                <button class="plus" style="cursor: pointer;" @click="addOne">
                    <i class="gli-next"/>
                </button>
            </div>
            <template
                v-else
            >
                {{ quant }}
            </template>
        </td>
        <td>
            {{ price | num_format }} &euro;
        </td>
        <td
            v-if="editable"
        >
            <button
                class="delete"
                style="cursor: pointer;"
                @click="deleteArticle(id)"
            >
                <i class="gli-close"/>
            </button>
        </td>
    </tr>
</template>

<script>
    import { isNil } from 'ramda';

    export default {
        name: 'shop-article',
        props: {
            id: {
                type: String,
                required: true
            },
            image: {
                type: String,
                required: true
            },
            icon: {
                type: String
            },
            title: {
                type: String,
                required: true
            },
            quantity: {
                type: Number,
                default: 1
            },
            price: {
                type: Number,
                default: 0
            },
            attributes: {
                type: Object
            },
            editable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                quant: this.quantity
            };
        },
        computed: {
            hasIcon() {
                return !isNil(this.icon);
            },
            isTransfer() {
                return this.id.indexOf('transfer') >= 0;
            }
        },
        methods: {
            addOne() {
                this.quant += 1;
                this.update();
            },
            removeOne() {
                this.quant -= 1;
                if (this.quant < 1) {
                    this.quant = 1;
                }
                this.update();
            },
            update() {
                const article = {
                    id: this.id,
                    image: this.image,
                    title: this.title,
                    quantity: this.quant,
                    price: this.price
                };
                this.$emit('update', article);
            },
            deleteArticle(item) {
                this.$emit('delete', item);
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ShopArticle.vue